import { SITES } from "@/lib/site";
import { Shell } from "./Shell";

export default function DevIndex() {
  return (
    <Shell testid="dev-index">
      <div className="px-6 sm:px-14 pt-12 max-w-2xl">
        <div className="text-[10px] tracking-[0.35em] text-[color:var(--w1-amber)] mb-3">PREVIEW // SITE SWITCHER</div>
        <h1 className="w1-display text-3xl sm:text-4xl text-[color:var(--w1-blue)] mb-3">333SOS</h1>
        <p className="text-xs text-[color:var(--w1-muted)] mb-10 leading-6">
          This page only exists on the preview host. On the real domains each site loads by its own address.
        </p>
        <ul className="space-y-3">
          {Object.entries(SITES).filter(([, k]) => k !== "redirect").map(([d, k]) => (
            <li key={d}>
              <a data-testid={`dev-site-link-${d}`} href={`/?site=${d}`} className="group flex items-baseline gap-4 text-sm hover:text-[color:var(--w1-blue)] transition-colors">
                <span className="w-40">{d}</span><span className="text-[10px] tracking-widest text-[color:var(--w1-muted)] group-hover:text-[color:var(--w1-blue-dim)]">{k.toUpperCase()}</span>
              </a>
            </li>
          ))}
        </ul>
        <p className="mt-10 text-[11px] text-[color:var(--w1-muted)]">Back to this list: <a className="underline" href="/?site=index" data-testid="dev-site-reset">/?site=index</a></p>
      </div>
    </Shell>
  );
}
